import { Outlet } from "react-router-dom";

const Electricity = () => {
  return (
    <div className="bg-white">
      <Outlet />
    </div>
  );
};

export default Electricity;
